export function MySQLConfigurationPage() {
  return (
    <div className="space-y-10">
      <div className="space-y-4">
        <h1 className="text-4xl font-bold">Configuration - MySQL Template</h1>
        <p className="text-lg text-muted-foreground max-w-4xl leading-relaxed">
          Learn how to configure your MySQL application environment.
        </p>
      </div>

      <div className="space-y-6">
        <h2 className="text-2xl font-bold">Environment Variables</h2>
        <p className="text-muted-foreground leading-relaxed">
          The template uses environment variables for configuration. Copy <code className="bg-muted px-2 py-1 rounded">env.sample</code> to 
          <code className="bg-muted px-2 py-1 rounded">.env</code> and configure the following variables:
        </p>
      </div>

      <div className="bg-muted/30 rounded-xl p-8 space-y-6">
        <h3 className="text-xl font-semibold">Database Configuration</h3>
        <pre className="bg-muted p-6 rounded-lg overflow-x-auto text-sm">
          <code>{`# Database
DB_TYPE=mysql
DB_HOST=localhost
DB_PORT=3306
DB_USERNAME=root
DB_PASSWORD=your_password
DB_DATABASE=nest_template
DB_SYNCHRONIZE=false  # Set to true only in development
DB_LOGGING=false`}</code>
        </pre>
      </div>

      <div className="bg-muted/30 rounded-xl p-8 space-y-6">
        <h3 className="text-xl font-semibold">JWT Configuration</h3>
        <pre className="bg-muted p-6 rounded-lg overflow-x-auto text-sm">
          <code>{`# JWT Secrets
JWT_SECRET=your-very-long-and-secure-jwt-secret-key
JWT_REFRESH_SECRET=your-very-long-and-secure-refresh-secret-key

# JWT Expiration
JWT_EXPIRES_IN=15m
JWT_REFRESH_EXPIRES_IN=7d`}</code>
        </pre>
      </div>

      <div className="bg-muted/30 rounded-xl p-8 space-y-6">
        <h3 className="text-xl font-semibold">OAuth Configuration</h3>
        <pre className="bg-muted p-6 rounded-lg overflow-x-auto text-sm">
          <code>{`# Google OAuth
GOOGLE_CLIENT_ID=your-google-client-id
GOOGLE_CLIENT_SECRET=your-google-client-secret
GOOGLE_CALLBACK_URL=http://localhost:3000/auth/google/callback`}</code>
        </pre>
      </div>

      <div className="bg-muted/30 rounded-xl p-8 space-y-6">
        <h3 className="text-xl font-semibold">Application Configuration</h3>
        <pre className="bg-muted p-6 rounded-lg overflow-x-auto text-sm">
          <code>{`# Application
NODE_ENV=development
PORT=3000
FRONTEND_URL=http://localhost:5173

# Security
BCRYPT_ROUNDS=10`}</code>
        </pre>
      </div>

      <div className="bg-primary/5 border-l-4 border-primary rounded-r-lg p-6 mt-8">
        <p className="text-sm font-semibold mb-2">🔒 Security Notes</p>
        <ul className="space-y-2 text-sm">
          <li>• Never commit .env files to version control</li>
          <li>• Use strong, randomly generated secrets for JWT</li>
          <li>• Set DB_SYNCHRONIZE to false in production</li>
          <li>• Use environment-specific variables for different stages</li>
          <li>• Regularly rotate secrets and credentials</li>
        </ul>
      </div>

      <div className="space-y-6 mt-8">
        <h2 className="text-2xl font-bold">TypeORM Configuration</h2>
        <p className="text-muted-foreground leading-relaxed">
          The template includes a dedicated TypeORM configuration file for CLI operations:
        </p>
        <div className="bg-card border rounded-xl p-6">
          <pre className="bg-muted p-4 rounded text-sm overflow-x-auto">
            <code>{`// src/config/typeorm.config.ts
import { DataSource } from 'typeorm';
import { config } from 'dotenv';

config();

export default new DataSource({
  type: 'mysql',
  host: process.env.DB_HOST,
  port: parseInt(process.env.DB_PORT || '3306'),
  username: process.env.DB_USERNAME,
  password: process.env.DB_PASSWORD,
  database: process.env.DB_DATABASE,
  entities: ['src/**/*.entity.ts'],
  migrations: ['src/migrations/*.ts'],
});`}</code>
          </pre>
        </div>
      </div>
    </div>
  )
}

